import React from "react";
import { connect } from "react-redux";
import ConfigurationElement from "./configuration-element";
import AddConfigurationElementObject from "./add-configuration-element-object";
import {
  Button,
  ButtonToolbar,
  Col,
  Glyphicon,
  Grid,
  Row,
} from "react-bootstrap";
import toastr from "toastr";
import { ElementStatus, DataType, Tag, Column, FieldToMatch } from "./constant";
import { Panel } from "../../Panel";

class AddConfiguration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      configName: props.configName,
      hasConfigurationOperator:
        (props.fieldToMatch & FieldToMatch.Configuration) ===
        FieldToMatch.Configuration,
      hasElementObjectOperator:
        (props.fieldToMatch & FieldToMatch.ElementObject) ===
        FieldToMatch.ElementObject,
      hasElementFieldOperator:
        (props.fieldToMatch & FieldToMatch.ElementField) ===
        FieldToMatch.ElementField,

      configurations: props.configurations,
      firmwares: props.firmwares,
      isMandatoryUpdate: props.isMandatoryUpdate ?? false
    };

    this.onMatchListRowClick = this.onMatchListRowClick.bind(this);
    this.onHandleChange = this.onHandleChange.bind(this);
    this.onHandleChangeConfigName = this.onHandleChangeConfigName.bind(this);
    this.onRemoveElement = this.onRemoveElement.bind(this);
    this.onAddElementObject = this.onAddElementObject.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.handleOperatorChange = this.handleOperatorChange.bind(this);
    this.onChangeIsMandatoryUpdate = this.onChangeIsMandatoryUpdate.bind(this);
  }

  onMatchListRowClick(configId, item) {
    const setValue = (array, id, valuesGroupId, name) => {
      return array.map((item) => {
        if (item["id"] === id) {
          return {
            ...item,
            ...{
              hasChanged: true,
              value: valuesGroupId,
              displayValue: name,
            },
          };
        } else {
          return item;
        }
      });
    };

    const updatedConfigurations = setValue(
      this.state.configurations,
      configId,
      item.id,
      item.name
    );

    //update configurations
    this.setState((state) => {
      return { ...state, configurations: updatedConfigurations };
    });
  }

  onChangeIsMandatoryUpdate(event) {
    // change value upon checkbox onClick
    this.setState({
      isMandatoryUpdate: event.target.checked
    });
  }

  onHandleChange(event, column, dataType) {
    //find object in array and update its data.
    const setValuesToFields = (array, target, column, dataType) => {
      return array.map((item) => {
        if (item["id"] === target.id) {
          let value;
          let displayValue;

          if (column === Column.Value && item.fieldName === "type") {
            value = parseInt(target.value);
            displayValue =
              event.nativeEvent.target[event.nativeEvent.target.selectedIndex]
                .text;
          } else if (column === Column.Value && target.type === "checkbox") {
            value = target.checked;
            displayValue = value;
          } else if (
            dataType === DataType.Boolean &&
            target.type === "select-one"
          ) {
            value = false;
            displayValue = value;
          } else if (column === Column.IncludeInRecipe) {
            // BS method!
          } else if (
            column === Column.Tag &&
            parseInt(target.value) === Tag.Match || !column === Column.IncludeInRecipe
          ) {
              value = "0";
              displayValue = value;  
          } else if(column === Column.Tag && 
            (parseInt(target.value) === Tag.Matchlist ||  parseInt(target.value) === Tag.Info) ||
            (item.tag === Tag.Matchlist && !column === Column.IncludeInRecipe)
          ){
              value = "";
              displayValue = value;
          }
          else {
            value = column === Column.Value ? target.value : item.value;
            displayValue = value;
          }

          return {
            ...item,
            ...{
              hasChanged: true,
              includeInRecipe:
                column === Column.IncludeInRecipe
                  ? target.checked
                  : item.includeInRecipe,
              tag: column === Column.Tag ? parseInt(target.value) : item.tag,
              value: value, 
              displayValue: displayValue,
            },
          };
        } else {
          return item;
        }
      });
    };

    const updatedConfigurations = setValuesToFields(
      this.state.configurations,
      event.target,
      column,
      dataType
    );
    //update configurations
    this.setState((state) => {
      return { ...state, configurations: updatedConfigurations };
    });
  }

  onHandleChangeConfigName(event) {
    this.setState({
      configName: event.target.value,
    });
  }

  onAdd(field) {
    this.setState((state) => {
      return { ...state, configurations: [...state.configurations, field] };
    });
  }

  onAddElementObject(elements, path) {
    //add newly added elements to configurations.
    elements.forEach((element) => {
      this.setState((state) => {
        return { ...state, configurations: [...state.configurations, element] };
      });
    });

    let seq = this.state.firmwares.length;
    //add newly added object to firmwares.
    this.setState((state) => {
      return {
        ...state,
        firmwares: [
          ...state.firmwares,
          {
            path: path,
            Id: "",
            fileName: "",
            fileSize: 0,
            fileType: "",
            sha256: "",
            sequence: seq++,
            isDeleted: false,
            isRequired: false,
            hasChanged: false,
            elementStatus: ElementStatus.NEW,
            disabled: false,
          },
        ],
      };
    });
  }

  onRemoveElement(id, path) {
    //set the isDeleted field to True.
    let udpatedConfigurations = this.setObjectAsDeleted(
      this.state.configurations,
      "id",
      id
    );

    //update configurations
    this.setState((state) => {
      return { ...state, configurations: udpatedConfigurations };
    });

    //get objects according to the path of deleted element.
    let elementObject = udpatedConfigurations.filter((x) => {
      if (x.path === path && !x.isDeleted) {
        return x;
      }
    });

    //check if all elements in object has been deleted. If so - tag the object itself as Deleted.
    if (
      elementObject.length === 1 &&
      elementObject[0].dataType === DataType.Object
    ) {
      let result = this.setObjectAsDeleted(
        udpatedConfigurations,
        "id",
        elementObject[0].id
      );

      this.setState((state) => {
        return { ...state, configurations: result };
      });

      let updatedFirmwares = this.setObjectAsDeleted(
        this.state.firmwares,
        "path",
        path
      );
      this.setState((state) => {
        return { ...state, firmwares: updatedFirmwares };
      });
    }
  }

  setObjectAsDeleted(array, field, value) {
    return array.map((item) => {
      if (item[field] !== value) {
        return item;
      }

      return {
        ...item,
        ...{ isDeleted: true, hasChanged: true },
      };
    });
  }

  predicate() {
    let fields = [],
      n_fields = arguments.length,
      field,
      name,
      cmp;

    let default_cmp = function (a, b) {
        if (a === b) return 0;
        return a < b ? -1 : 1;
      },
      getCmpFunc = function (primer, reverse) {
        let dfc = default_cmp,
          // closer in scope
          cmp = default_cmp;
        if (primer) {
          cmp = function (a, b) {
            return dfc(primer(a), primer(b));
          };
        }
        if (reverse) {
          return function (a, b) {
            return -1 * cmp(a, b);
          };
        }
        return cmp;
      };

    // preprocess sorting options
    for (var i = 0; i < n_fields; i++) {
      field = arguments[i];
      if (typeof field === "string") {
        name = field;
        cmp = default_cmp;
      } else {
        name = field.name;
        cmp = getCmpFunc(field.primer, field.reverse);
      }
      fields.push({
        name: name,
        cmp: cmp,
      });
    }

    // final comparison function
    return function (A, B) {
      var name, result;
      for (var i = 0; i < n_fields; i++) {
        result = 0;
        field = fields[i];
        name = field.name;

        result = field.cmp(A[name], B[name]);
        if (result !== 0) break;
      }
      return result;
    };
  }

  onNext() {
    let haveError;
    if (this.state.configName === undefined || this.state.configName === "") {
      haveError = true;
      toastr.error("Configuration Name is required.", "Error");
    }
    if (
      this.state.configurations.find(
        (i) =>
          i.tag === Tag.Matchlist &&
          i.fieldName !== "type" &&
          (i.displayValue === undefined ||
            i.displayValue === "" ||
            i.value === undefined ||
            i.value === "")
      )
    ) {
      haveError = true;
      toastr.error("Group value not selected.", "Error");
    }

    if (!haveError) {
      var fieldToMatch = FieldToMatch.None;
      if (this.state.hasConfigurationOperator) {
        fieldToMatch = fieldToMatch | FieldToMatch.Configuration;
      }

      if (this.state.hasElementObjectOperator) {
        fieldToMatch = fieldToMatch | FieldToMatch.ElementObject;
      }

      if (this.state.hasElementFieldOperator) {
        fieldToMatch = fieldToMatch | FieldToMatch.ElementField;
      }

      const filteredUnitVersionConfigurations = this.state.configurations.map(configuration => {
        if(configuration.recipeFieldName === 'unit_version' && configuration.value === '') {
          configuration.value = "0";
        }
        return configuration;
      });
      

      this.props.onNext(
        this.state.configName,
        fieldToMatch,
        filteredUnitVersionConfigurations,
        this.state.firmwares,
        this.state.isMandatoryUpdate
      );
    }
  }

  onCancel() {
    this.props.history.push("/Configuration");
  }

  handleOperatorChange(event) {
    var name = event.target.name;
    var isAndValue = Boolean(Number(event.target.value));

    if (name === "configurationOperator") {
      this.setState({ hasConfigurationOperator: isAndValue });
    } else if (name === "elementObjectOperator") {
      this.setState({ hasElementObjectOperator: isAndValue });
    } else if (name === "elementFieldOperator") {
      this.setState({ hasElementFieldOperator: isAndValue });
    }
  }

  render() {
    return (
      <Grid fluid>
        <h1>Setup Configuration</h1>
        <Row>
          <Col sm={12}>
            <Panel>
              <div className="panel-body">
                <div className="row">
                  <div className="col-sm-8">
                    <div className="form-horizontal">
                      <div className="form-group">
                        <label
                          for="configurationName"
                          className="col-sm-2 control-label"
                        >
                          Configuration Name
                        </label>
                        <div className="col-sm-6">
                          <input
                            id="configurationName"
                            className="form-control"
                            type="text"
                            placeholder="Configuration Name"
                            required
                            value={this.state.configName}
                            onChange={this.onHandleChangeConfigName}
                          />
                        </div>
                        <div className="col-sm-4">
                          <label>
                          <input
                            type="checkbox"
                            checked={this.state.isMandatoryUpdate}
                            onChange={this.onChangeIsMandatoryUpdate}
                          />
                          {' '}Is Mandatory Update?
                          </label>
                          </div>
                      </div>
                      <fieldset>
                        <legend>
                          <p className="text-uppercase">
                            <strong>Device</strong>
                          </p>
                        </legend>
                      </fieldset>
                      {(() => {
                        var controls = [];
                        let configurations = this.state.configurations.sort(
                          this.predicate(
                            {
                              name: "path",
                            },
                            "sequence"
                          )
                        );

                        for (var key in configurations) {
                          if (configurations.hasOwnProperty(key)) {
                            let filteredConfigByPath = configurations.filter(
                              (x) => {
                                if (
                                  x.path === configurations[key]["path"] &&
                                  !x.isDeleted
                                ) {
                                  return x;
                                }
                              }
                            );

                            let displayAddFieldButton = false;
                            if (filteredConfigByPath.length > 0) {
                              displayAddFieldButton =
                                configurations[key]["id"] ===
                                filteredConfigByPath[
                                  filteredConfigByPath.length - 1
                                ]["id"];
                            }

                            if (!configurations[key]["isDeleted"]) {
                              let fieldPathIndex =
                                configurations[key]["path"].split(".").length -
                                1;

                              //object - with field NOT equal *. ex: configuration
                              if (
                                configurations[key]["dataType"] ===
                                  DataType.Object &&
                                configurations[key]["fieldName"] != "*"
                              ) {
                                controls.push(
                                  <div>
                                    <br />
                                    <br />
                                    <fieldset>
                                      <legend>
                                        <p className="text-uppercase">
                                          <strong>
                                            {configurations[key]["fieldName"]}
                                          </strong>
                                        </p>
                                        <div className="form-group">
                                          <label
                                            style={{ fontSize: "13px" }}
                                            className="col-sm-2 control-label"
                                          >
                                            Field Operator
                                          </label>
                                          <div className="col-sm-2">
                                            <select
                                              name="configurationOperator"
                                              className="form-control input-sm"
                                              value={Number(
                                                this.state
                                                  .hasConfigurationOperator
                                              )}
                                              onChange={
                                                this.handleOperatorChange
                                              }
                                            >
                                              <option value="1">And</option>
                                              <option value="0">Or</option>
                                            </select>
                                          </div>
                                        </div>
                                      </legend>
                                    </fieldset>
                                  </div>
                                );
                              }
                              // //object - with field equal *
                              // else if (configurations[key]['dataType'] === DataType.Object && configurations[key]['fieldName'] === '*') {
                              //     controls.push(
                              //         <br />)
                              // }
                              //array
                              else if (
                                configurations[key]["dataType"] ===
                                DataType.Array
                              ) {
                                controls.push(
                                  <fieldset>
                                    <legend>
                                      <p className="text-uppercase">
                                        <span
                                          style={{ verticalAlign: "middle" }}
                                        >
                                          <strong>
                                            {configurations[key]["fieldName"]}{" "}
                                          </strong>
                                        </span>
                                        <AddConfigurationElementObject
                                          arrayId={configurations[key]["id"]}
                                          configurations={
                                            this.state.configurations
                                          }
                                          firmwares={this.state.firmwares}
                                          path={configurations[key]["path"]}
                                          onAdd={this.onAddElementObject}
                                        />
                                      </p>
                                      <div className="form-group">
                                        <label
                                          style={{ fontSize: "13px" }}
                                          className="col-sm-2 control-label"
                                        >
                                          Object Operator
                                        </label>
                                        <div className="col-sm-2">
                                          <select
                                            name="elementObjectOperator"
                                            className="form-control input-sm"
                                            value={Number(
                                              this.state
                                                .hasElementObjectOperator
                                            )}
                                            onChange={this.handleOperatorChange}
                                          >
                                            <option value="1">And</option>
                                            <option value="0">Or</option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label
                                          style={{ fontSize: "13px" }}
                                          className="control-label col-sm-2"
                                        >
                                          Field Operator
                                        </label>
                                        <div className="col-sm-2">
                                          <select
                                            name="elementFieldOperator"
                                            className="form-control input-sm"
                                            value={Number(
                                              this.state.hasElementFieldOperator
                                            )}
                                            onChange={this.handleOperatorChange}
                                          >
                                            <option value="1">And</option>
                                            <option value="0">Or</option>
                                          </select>
                                        </div>
                                      </div>
                                    </legend>
                                  </fieldset>
                                );
                              }
                              //fields
                              else if (
                                configurations[key]["dataType"] ===
                                  DataType.String ||
                                configurations[key]["dataType"] ===
                                  DataType.Integer ||
                                configurations[key]["dataType"] ===
                                  DataType.Boolean ||
                                configurations[key]["dataType"] ===
                                  DataType.Date
                              ) {
                                controls.push(
                                  <ConfigurationElement
                                    configurationName={this.state.configName}
                                    configuration={configurations[key]}
                                    configurations={this.state.configurations}
                                    displayAddButton={displayAddFieldButton}
                                    onAdd={this.onAdd}
                                    onHandleChange={this.onHandleChange}
                                    onRemove={this.onRemoveElement}
                                    onMatchListRowClick={
                                      this.onMatchListRowClick
                                    }
                                  />
                                );
                              }
                            }
                          }
                        }
                        return controls;
                      })()}
                    </div>
                  </div>
                </div>
                <ButtonToolbar className="pull-right">
                  <Button
                    bsStyle="primary"
                    id="btnCancel"
                    onClick={() => {
                      this.onCancel();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    bsStyle="primary"
                    id="btnNext"
                    onClick={() => {
                      this.onNext();
                    }}
                  >
                    Next <Glyphicon glyph="arrow-right" />
                  </Button>
                </ButtonToolbar>
              </div>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default connect()(AddConfiguration);
